"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function MasterdbBlueMulticolorFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#BDF6FF",
    d: "M13.576 3.101a.367.367 0 00-.122-.283v-.04c-.12-.121-.242-.202-.363-.283-.202-.121-.404-.202-.606-.323-.445-.202-.93-.324-1.414-.445-.283-.08-.566-.12-.849-.202-.242-.04-.444-.08-.687-.12H8.89c-.404-.041-.808-.082-1.293-.082H6.222c-.444 0-.889.04-1.293.081l-.606.08c-.242.041-.485.082-.687.122-.323.04-.606.121-.889.202-.444.121-.929.243-1.373.445-.202.08-.404.202-.606.323-.122.04-.283.161-.404.242v.04c-.04.081-.122.162-.122.243h-.04v9.737c0 1.05 2.869 1.859 6.707 1.859 3.838 0 6.707-.808 6.707-1.859l-.04-9.737z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M6.95 1.687c2.99 0 5.252.727 6.02 1.212-.728.444-3.03 1.212-6.02 1.212-2.99 0-5.253-.727-6.02-1.212.727-.444 3.03-1.212 6.02-1.212zm0-.687C3.11 1 0 2.212 0 2.899s3.111 1.899 6.95 1.899c3.838 0 6.949-1.212 6.949-1.899S10.788 1 6.949 1zM6.95 14.899c-3.96 0-6.95-.808-6.95-1.94h.768c.08.364 2.06 1.213 6.181 1.213 4.081 0 6.101-.89 6.182-1.212h.768c0 1.09-2.99 1.939-6.95 1.939zM6.95 11.424c-3.96 0-6.95-.808-6.95-1.94h.768c.08.364 2.06 1.213 6.181 1.213 4.081 0 6.101-.889 6.182-1.212h.768c0 1.131-2.99 1.94-6.95 1.94zM6.95 7.95C2.99 7.95 0 7.14 0 6.01h.768c.08.364 2.06 1.212 6.181 1.212 4.081 0 6.101-.889 6.182-1.212h.768c0 1.131-2.99 1.94-6.95 1.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008DE5",
    d: "M.768 2.899H0v10.06h.768V2.9zM13.899 2.899h-.768v10.06h.768V2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3E6CB",
    d: "M15.596 10.535a3.432 3.432 0 01-3.434 3.435 3.431 3.431 0 01-3.435-3.435 3.431 3.431 0 013.435-3.434 3.432 3.432 0 013.434 3.434z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28A745",
    d: "M12.162 14.414a3.837 3.837 0 01-3.839-3.838c0-2.101 1.738-3.839 3.839-3.839A3.837 3.837 0 0116 10.576c0 2.1-1.737 3.838-3.838 3.838zm0-6.909a3.026 3.026 0 00-3.03 3.03c0 1.657 1.373 3.03 3.03 3.03a3.026 3.026 0 003.03-3.03c0-1.656-1.374-3.03-3.03-3.03z"
  }));
}

MasterdbBlueMulticolorFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
MasterdbBlueMulticolorFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = MasterdbBlueMulticolorFilled;
exports["default"] = _default;